import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { appInfo } from 'wap/hybrid/device.js'
import { excludeMessages } from '@ms/utils-es/error'

const dsn = process.env.VUE_APP_SENTRY_DSN

const denyStackReg = /\[native code\]|chunk-sentry/i

if (dsn) {
  const { region, appName, appVersion, wapVersion, platform, store } = appInfo
  const sampleRate = /test/.test(location.host) ? 1 : 0.01

  Sentry.setTags({
    region,
    appName,
    appVersion,
    platform,
    store
  })

  Sentry.init({
    release: 'hopegaming@' + wapVersion,
    Vue,
    dsn,
    tracesSampleRate: sampleRate,
    replaysSessionSampleRate: 0.001,
    replaysOnErrorSampleRate: 0.001,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: [process.env.VUE_APP_SENTRY_APPLICATION_KEY],
        behaviour: 'drop-error-if-contains-third-party-frames' // 过滤策略
      })
    ],
    ignoreErrors: excludeMessages,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (error) {
        const stack = error.stack || error.error?.stack || ''
        if (!error.message) {
          return null
        }
        if (stack && (!/msport\.com/.test(stack) || denyStackReg.test(stack))) {
          return null
        }
      }
      return event
    }
  })
}

/**
 * 前端埋点上报方法, 设置 window.DEBUG_TRACE = true 可查看 log
 * @param {String} event  上报的 key, 一般是需求方提供的字符串
 * @param {Object} body   自定义上报参数，按需求添加
 */
export function mstrace(event = '', body = {}) {
  if (!event) {
    console.log('trace error with no event')
    return
  }
  const options = { event }

  if (body) {
    Object.assign(options, { ...body })
  }
  try {
    window.DEBUG_TRACE && console.trace('Trace: ', options)
    window.dataLayer?.push(options)
  } catch (error) {
    console.error(error)
  }
}

window.mstrace = mstrace

export const integrateRouter = (router) => {
  dsn && Sentry.addIntegration(Sentry.browserTracingIntegration({ router }))
}
